// extracted by mini-css-extract-plugin
module.exports = {"disabledArrows":"BasicInfo_disabledArrows__1FQLj"};